// extracted by mini-css-extract-plugin
export default {"auctionTitle":"title_auctionTitle__5xCPi","url":"title_url__2abeE","aucTitle":"title_aucTitle__ly3OL"};